import { setUserId, setUserProperties } from 'firebase/analytics';
import { getAppEnv, getFirebaseAnalytics } from '../config/firebase';

/**
 * Analytics に識別情報をセットする。
 * 個人情報（メール / 氏名）は送らない。Firebase の不透明 UID とロールのみ。
 *
 * @param uid - Firebase Authentication の uid
 * @param role - ユーザーのロール（FARMER / AREA_MANAGER / ADMIN 等）
 */
export const setAnalyticsUser = async (uid: string, role: string): Promise<void> => {
  const analytics = await getFirebaseAnalytics();
  if (!analytics) return;
  setUserId(analytics, uid);
  setUserProperties(analytics, {
    role,
    app_env: getAppEnv(),
    app_version: __APP_VERSION__,
  });
};

/**
 * Analytics の識別情報をクリアする（ログアウト時に呼ぶ）。
 * クライアント ID（匿名）は維持する。
 */
export const clearAnalyticsUser = async (): Promise<void> => {
  const analytics = await getFirebaseAnalytics();
  if (!analytics) return;
  setUserId(analytics, null);
  setUserProperties(analytics, { role: null });
};
